import React from 'react';
// tslint:disable-next-line: no-submodule-imports
import { FaTrash } from 'react-icons/fa';

import { DbKey, WithDbId } from '../../../../adl-gen/common/db';
import { AppClient, LearningProvider } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { EditIcon } from '../../../../ui/common/icons';
import { Button } from '../../../../ui/widgets/button/button';
import { SelectOption } from '../../../../ui/widgets/select/select';
import { DisplayCheckItem, DisplayImg, MultiSelectContainer, DisplaySelect, DisplayText } from '../../common/editor';
import { TabContainer } from '../tab-container/tab-container';

const styles = require('../../common/details-view.css');
const commonStyles = require('../../common/common.css');

/// TODO: Read from auth0tenant
/** @deprecated */
const defaultLoginBackground =
  'https://com-hx-futurefit-uat-resources.s3-ap-southeast-2.amazonaws.com/skillseeker/site-images/splash+screen+w1800.png';

interface AppClientDetailsViewProps {
  client: WithDbId<AppClient>;
  providers: WithDbId<LearningProvider>[];
  onUpdate(appClientId: DbKey<AppClient>): Promise<void>;
  role: 'client-admin' | 'super';
}

export class AppClientDetailsView extends React.Component<AppClientDetailsViewProps> {
  /// Sort this out later
  private readonly deleteAllowed: boolean = false;

  learningProviderOptions = (): SelectOption[] => {
    const { providerIds } = this.props.client.value;
    if (providerIds.length === 0) {
      return [{ value: 0, label: 'None' }];
    }
    const providerOptions = this.props.providers
      .filter(s => providerIds.includes(s.id))
      .map(s => ({ value: s.id, label: s.value.name }));
    return providerOptions;
  };

  ssoConnectionOption = (): SelectOption => {
    const { connectionName } = this.props.client.value;
    return connectionName === null
      ? { label: 'Not Using SSO', value: 'Not Using SSO' }
      : { label: connectionName, value: connectionName };
  };

  Name = DisplayText({
    field: this.props.client.value.name,
    title: 'Site Name',
    xsSpan: 2
  });
  DomainName = DisplayText({
    field: this.props.client.value.domainName,
    title: 'Domain Name',
    xsSpan: 2
  });
  Logo = DisplayImg({
    field: this.props.client.value.logoUrl,
    height: 50,
    xsSpan: 1
  });
  BackgroundImage = DisplayImg({
    field:
      this.props.client.value.loginBackgroundUrl.kind === 'default'
        ? defaultLoginBackground
        : this.props.client.value.loginBackgroundUrl.value,
    height: 600,
    xsSpan: 1
  });

  RecommendationsVisible = DisplayCheckItem({
    field: this.props.client.value.recommendationsVisible,
    label: 'Recommendations Visible',
    xsSpan: 2
  });
  RecreateUserQuizEnabled = DisplayCheckItem({
    field: this.props.client.value.recreateUserQuizEnabled,
    label: 'Automatic Reassess Enabled',
    xsSpan: 2
  });
  RecommendationProviders = MultiSelectContainer({
    options: this.learningProviderOptions(),
    selectedOptions: this.learningProviderOptions(),
    title: 'Learning Providers to filter recommendations',
    xsSpan: 2
  });

  WalkthroughsEnabled = DisplayCheckItem({
    field: this.props.client.value.walkthroughsEnabled,
    label: 'Walkthroughs Enabled',
    xsSpan: 2
  });
  WalkthroughsOnFirstUse = DisplayCheckItem({
    field: this.props.client.value.skipIfAlreadySeen,
    label: 'Walkthroughs on First Visit Only',
    xsSpan: 2
  });

  Auth0Domain = DisplayText({
    field: this.props.client.value.auth0Domain,
    title: 'Auth0 Domain',
    xsSpan: 2
  });
  Auth0ClientId = DisplayText({
    field: this.props.client.value.auth0ClientId,
    title: 'Auth0 Client ID',
    xsSpan: 2
  });
  DebugReporting = DisplayCheckItem({
    field: this.props.client.value.debugReporting,
    label: 'Show scores not percentages in results',
    xsSpan: 2
  });
  DisplayHeadlineRatio = DisplayCheckItem({
    field: this.props.client.value.displayHeadlineRatio,
    label: "Display 'Headline' Score in Quiz Results",
    xsSpan: 2
  });
  DisplayHeadlineText = DisplayCheckItem({
    field: this.props.client.value.displayHeadlineText,
    label: 'Display explanatory text (for percentages) in Quiz Results',
    xsSpan: 2
  });
  TabbedRecommendations = DisplayCheckItem({
    field: this.props.client.value.singleTabRecommendations,
    label: 'Recommendations page with no tabs (off = tabbed on Category)',
    xsSpan: 2
  });
  AllowSelfAssessments = DisplayCheckItem({
    field: this.props.client.value.allowSelfAssessment,
    label: 'Using Self-Assessments instead of Quizzes',
    xsSpan: 2
  });
  DisplayClientAssessmentsOnly = DisplayCheckItem({
    field: this.props.client.value.displayClientAssessmentsOnly,
    label: 'Only display assessments generated from Roles owned by this client',
    xsSpan: 2
  });

  SSOConnection = DisplaySelect({
    options: [this.ssoConnectionOption()],
    selectedOption: this.ssoConnectionOption(),
    title: 'SSO Connection',
    xsSpan: 2
  });

  /// TODO Replace all these divs with a flexbox and flex items
  renderTopButtons = () => {
    const updateButton = () => {
      return (
        <div className={commonStyles.buttonList}>
          <Button
            // onClick={async () => this.start("update")}
            onClick={async () => this.props.onUpdate(this.props.client.id)}
            Icon={EditIcon}
            size="small"
            variant="round"
          // disabled={this.editable() === undefined}
          >
            Update
          </Button>
        </div>
      );
    };

    const deleteButton = () => {
      return (
        <div className={commonStyles.buttonList}>
          <Button
            // onClick={async () => this.start("delete")}
            Icon={FaTrash}
            size="small"
            variant="round"
          // disabled={this.selected.size === 0}
          >
            Delete
          </Button>
        </div>
      );
    };

    return (
      <div className={commonStyles.buttonListContainer}>
        {this.deleteAllowed && deleteButton()}
        {updateButton()}
      </div>
    );
  };

  renderDetails = () => (
    <div className={styles.page}>
      <div className={styles.body}>
        <div>{this.renderTopButtons()}</div>
        <div className={styles.row}>
          {this.Name}
          {this.DomainName}
        </div>
        <div className={styles.row}>
          {this.RecommendationsVisible}
          {this.props.role === 'super' && this.RecreateUserQuizEnabled}
          {this.WalkthroughsEnabled}
          {this.WalkthroughsOnFirstUse}
          {this.props.role === 'super' && this.DebugReporting}
          {this.DisplayHeadlineRatio}
          {this.DisplayHeadlineText}
          {this.props.role === 'super' && this.TabbedRecommendations}
          {this.AllowSelfAssessments}
          {this.DisplayClientAssessmentsOnly}
        </div>
        <div className={styles.row}>
          {this.RecommendationProviders}
          {this.SSOConnection}
        </div>
        <div className={styles.row}>
          {this.props.role === 'super' && this.Auth0Domain}
          {this.props.role === 'super' && this.Auth0ClientId}
        </div>
      </div>
    </div>
  );

  render() {
    const {
      client
      // licenceStore
    } = this.props;
    if (client) {
      // MobX warning on updating State during render - moved to licenceState()
      // licenceStore.setClientFilter(client);
      return (
        <TabContainer
          items={[
            {
              key: 0,
              title: 'Settings',
              content: this.renderDetails(),
              selected: true
            },
            {
              key: 1,
              title: 'Logo',
              content: this.Logo,
              selected: false
            },
            {
              key: 2,
              title: 'Login Background',
              content: this.BackgroundImage,
              selected: false
            }
          ]}
          selectedTabKey={0}
        />
      );
      // return this.renderDetails();
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/detail-views/appclient-details-view.tsx